import { render, staticRenderFns } from "./bottomBanner.vue?vue&type=template&id=350a8025&scoped=true"
import script from "./bottomBanner.vue?vue&type=script&lang=js"
export * from "./bottomBanner.vue?vue&type=script&lang=js"
import style0 from "./bottomBanner.vue?vue&type=style&index=0&id=350a8025&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a8025",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('350a8025')) {
      api.createRecord('350a8025', component.options)
    } else {
      api.reload('350a8025', component.options)
    }
    module.hot.accept("./bottomBanner.vue?vue&type=template&id=350a8025&scoped=true", function () {
      api.rerender('350a8025', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/advertising/bottomBanner.vue"
export default component.exports